import React, { useState } from "react";
import Collapsible from "./../../Collapsible";
import { FilterLabelTranslations } from "../utils/FilterLabelTranslations";
import { PanelHeadingProps, RefinementPanelProps } from "./types/Panel";
import { useCurrentRefinements } from "react-instantsearch";

export const RefinementPanel = ({
  attribute,
  children,
  disabledFilters,
  className,
  openedOnInit = false,
}: RefinementPanelProps) => {
  const { items } = useCurrentRefinements();

  return (
    <div
      data-refinement-list-insights
      data-refinement-list={attribute}
      className={`${className} ${
        disabledFilters.includes(attribute) ? "hidden" : ""
      }`}
    >
      <Panel
        header={
          <PanelHeading
            headerText={FilterLabelTranslations[attribute]}
            headerTotal={items
              .filter((item) => item.attribute === attribute)
              .reduce((total, item) => total + item.refinements.length, 0)}
          />
        }
        openedOnInit={openedOnInit}
      >
        {children}
      </Panel>
    </div>
  );
};

export const PanelHeading = ({
  headerText,
  headerTotal,
}: PanelHeadingProps) => {
  return (
    <>
      {headerTotal > 0 ? (
        <div>
          {headerText}
          <span className="algolia-panel-heading-total">({headerTotal})</span>
        </div>
      ) : (
        <div>{headerText}</div>
      )}
    </>
  );
};

export function Panel({
  children,
  header,
  footer,
  openedOnInit = false,
}: {
  children: React.ReactNode;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  openedOnInit?: boolean;
}) {
  const [isOpen, setIsOpen] = useState(openedOnInit);

  return (
    <Collapsible
      initiallyOpen={openedOnInit}
      label={header}
      className={
        "filter-group filter-group-algolia" +
        (isOpen ? " filter-group--open" : "")
      }
      onStateChange={(open) => setIsOpen(open)}
    >
      <div className="algolia-panel-body">{children}</div>
    </Collapsible>
  );
}

export function SimplePanel({
  children,
  header,
  footer,
}: {
  children: React.ReactNode;
  header?: React.ReactNode;
  footer?: React.ReactNode;
}) {
  return (
    <div className="algolia-panel">
      {header && <div className="algolia-panel-header">{header}</div>}
      <div className="algolia-panel-body">{children}</div>
      {footer && <div className="algolia-panel-footer">{footer}</div>}
    </div>
  );
}
